import * as React from 'react'
import BaseIcon from 'react-icon-base'

const PeerInvitationAcceptedIcon = props => (
  <BaseIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width="16" height="16" fill="#2ED8A7" rx="8" />
      <path
        fill="#FFF"
        d="M8.836 8.5A2.246 2.246 0 0 0 8 10.25c0 .707.326 1.338.836 1.75H4v-1.5a2 2 0 0 1 2-2h2.836zM10.25 12a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5zm.25-2V9H10v1H9v.5h1v1h.5v-1h1V10h-1zM8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
      />
    </g>
  </BaseIcon>
)

export default PeerInvitationAcceptedIcon
